export * from "./PaymentPageFooter";
